import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "emma_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const authHeaders = () => ({ Authorization: `Bearer ${getToken()}` });

// L'immagine può essere un URL esterno oppure un percorso dello storage interno
export const imageSrc = (image) =>
  image && image.startsWith("http") ? image : `${API}/files/${image}`;

export const fetchProducts = async () => {
  const { data } = await axios.get(`${API}/products`);
  return data;
};

export const formatApiError = (e) => {
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || "").filter(Boolean).join(" ");
  return "Qualcosa è andato storto. Riprova.";
};
